// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginaPrincipal_container__3UwvZ","title":"PaginaPrincipal_title__1Hy1e","pageNumbers":"PaginaPrincipal_pageNumbers__3VD08"};